import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { HeadshotUploadComponent } from "./headshot-upload.component";
import { BrowserModule } from "@angular/platform-browser";
import { IdUploadModalModule } from '../id-upload/id-upload-modal.module';
import { WebcamModule } from 'ngx-webcam';
import { HeaderModule } from '../header/header.module';
import { SessionTimeoutModalModule } from '../session-timeout-modal/session-timeout-modal.module';
import { ProgressBarModule } from "../progress-bar/progress-bar.module";
import { LivenessComponent } from "../liveness/liveness.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { BackButtonConfirmationModalModule } from "../back-button-confirmation-modal/back-button-confirmation-modal.module";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
  declarations: [
    HeadshotUploadComponent,
  ],
  providers: [
  ],
  imports: [
    BackButtonConfirmationModalModule,
    BrowserModule,
    CommonModule,
    WebcamModule,
    IdUploadModalModule,
    HeaderModule,
    SessionTimeoutModalModule,
    ProgressBarModule,
    LivenessComponent,
    MatProgressSpinnerModule,
    MatIconModule
  ],
})
export class HeadshotUploadModule {}
